// SectionCard.tsx
import React from "react";

interface SectionCardProps {
  step: number;
  title: string;
  children: React.ReactNode;
}

export default function SectionCard({ step, title, children }: SectionCardProps) {
  return (
    <div className="bg-white border border-gray-100 rounded-xl p-6 space-y-4">
      <div className="flex items-center gap-2">
        <span className="w-6 h-6 rounded-full bg-blue-500 text-white text-sm flex items-center justify-center">
          {step}
        </span>
        <h2 className="font-semibold text-gray-900">{title}</h2>
      </div>
      {children}
    </div>
  );
}
